import { render, staticRenderFns } from "./CompanyAddress.vue?vue&type=template&id=079f73bc&scoped=true&"
import script from "./CompanyAddress.vue?vue&type=script&lang=js&"
export * from "./CompanyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f73bc",
  null
  
)

export default component.exports